import React from 'react';
import { useTranslation } from 'react-i18next';
import './SearchBar.css';

interface SearchBarProps {
    value: string;
    onChange: (value: string) => void;
    placeholder?: string;
}

const SearchBar: React.FC<SearchBarProps> = ({ value, onChange, placeholder }) => {
    const { t } = useTranslation();

    return (
        <div className="search-bar">
            <div className="search-input-wrapper">
                <span className="search-icon">🔍</span>
                <input
                    type="text"
                    className="search-input"
                    value={value}
                    onChange={(e) => onChange(e.target.value)}
                    placeholder={placeholder || t('search.placeholder')}
                />
                {value && (
                    <button className="clear-btn" onClick={() => onChange('')}>
                        ✕
                    </button>
                )}
            </div>
        </div>
    );
};

export default SearchBar;
